import OrderDetailPage from './OrderDetailsPage';

export default OrderDetailPage;
